/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Col, Row, Form, Select, Space, Input, Modal } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import InstitutionUserService from '../../services/InstitutionUserService'

const { Option } = Select

const EditRefundRequestStatus = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const refundRequest = state || {}
  const bailiffRefundRequest = state || {}
  const [form] = Form.useForm()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [statusData, setStatusData] = useState<any>({})
  const [isEdit, setIsEdit] = useState(false)
  const [editStatusID, setEditStatusID] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const location = useLocation()
  const formatDate = ({ dateString }: { dateString: any }) => {
    if (!dateString) return '-'
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '-'
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (location.state != null) {
      const { status_id, status } = location?.state
      setIsEdit(true)
      setEditStatusID(status_id)
      form.setFieldsValue({ status, reason: null })
    }
  }, [form, location.state])

  const showModal = (): void => {
    setIsModalOpen(true)
  }

  const handleModalOk = (): void => {
    setLoading(true)
    updateRefundStatus()
      .then(() => {
        setError(null)
        Modal.success({
          title: 'Success',
          content: 'The refund request status has been updated successfully.'
        })
        navigate('/bank-transfer-update-status')
      })
      .catch((err: any) => {
        const backendMessage = err?.message || 'Failed to update refund request status.'
        setError(backendMessage)
        Modal.error({
          title: 'Error',
          content: backendMessage
        })
      })
      .finally(() => {
        setLoading(false)
        setIsModalOpen(false)
      })
  }

  const updateRefundStatus = async (): Promise<void> => {
    try {
      const transactionReference = refundRequest.transaction_reference
      const selectedStatus = form.getFieldValue('status')
      const reason = (form.getFieldValue('reason') ?? '').trim()

      if (!transactionReference || !selectedStatus || reason.length === 0) {
        throw new Error('Missing required fields to update refund status.')
      }

      const payload = {
        RefundRequests: [
          {
            transaction_reference: transactionReference,
            phone_number: refundRequest.phone_number
          }
        ],
        status: selectedStatus,
        reason
      }
      const response = await InstitutionUserService.editRefundRequestStatusMessage(payload)
      if (response?.status !== 200 || !Array.isArray(response?.data) || response.data.length === 0) {
        throw new Error(response?.message ?? 'No refund request was updated.')
      }
    } catch (err) {
      if (err instanceof Error) {
        throw err
      }
      throw new Error('Failed to update refund request status.')
    }
  }

  const handleModalCancel = (): void => {
    setIsModalOpen(false)
  }

  const onFinish = (values: any): void => {
    showModal()
    setStatusData(values)
  }
  return (
    <div className="w-full p-6 bg-gray-50">
      {/* Enhanced Custom CSS Styles */}
      <style>{
        `
        .enhanced-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-button {
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.2s ease;
        }
        .enhanced-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        .enhanced-input {
          border-radius: 8px;
          border: 2px solid #e5e7eb;
          transition: border-color 0.2s ease;
        }
        .enhanced-input:focus {
          border-color: #37762f;
          box-shadow: 0 0 0 3px rgba(55, 118, 47, 0.1);
        }
        .section-header {
          background: linear-gradient(135deg, #37762f 0%, #4a7c59 100%);
          color: white;
          padding: 12px 16px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 16px;
        }
        `
      }</style>
      
      {/* Enhanced Breadcrumb Navigation */}
      <div className="px-5 py-4 border-b border-gray-300" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px',
      }}>
        <div className="flex justify-between items-center">
          <div className="text-title font-semibold text-gray-800 flex items-center">
            <div style={{
              background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px',
              boxShadow: '0 4px 8px rgba(55, 118, 47, 0.3)',
            }}>
              <span style={{ fontSize: '18px' }}>✏️</span>
            </div>
            <div>
              <span
                className="cursor-pointer text-blue-600 hover:text-blue-700 enhanced-button"
                style={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                  transition: 'all 0.2s ease',
                }}
                onClick={() => navigate('/refund-request-list')}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(59, 130, 246, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.3)';
                }}
              >
                <i className="material-icons align-middle mr-2"></i>Edit Refund Request Status
              </span>
              {' > '}
              <span className="font-medium text-gray-600">{refundRequest?.beneficiary_account_name}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Beneficiary Refund Request Details Section */}
      <div className="px-7 py-4 mt-4 enhanced-card" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.2s ease',
      }}>
        <div className="section-header">
          <span style={{ fontSize: '18px' }}>💰</span>
          Beneficiary Refund Request Details
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Account Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_account_name}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Bank Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_bank_name}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Account Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_account_number}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Debit Account Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.debit_account_number}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Debit Account Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.debit_account_name}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Transaction Reference</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.transaction_reference}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Amount to be Refunded</div>
            <div className="text-base font-medium text-gray-500">{parseInt(String(refundRequest?.amount)).toLocaleString()}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Transaction Currency</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.transaction_currency}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Reason</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.reason}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Status</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.status}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Requested Date</div>
            <div className="text-base font-medium text-gray-500">{formatDate({ dateString: refundRequest?.created_at })}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Updated Date</div>
            <div className="text-base font-medium text-gray-500">{formatDate({ dateString: refundRequest?.updated_at })}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Phone Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.phone_number}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Amount to be Refunded</div>
            <div className="text-base font-medium text-gray-500">{parseInt(String(refundRequest?.amount)).toLocaleString()}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Amount to be Refunded</div>
            <div className="text-base font-medium text-gray-500">{parseInt(String(refundRequest?.amount)).toLocaleString()}</div>
          </Col>
        </Row>
      </div>

      {/* Update Refund Request Status Section */}
      <div className="px-7 py-4 mt-6 enhanced-card" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.2s ease',
      }}>
        <div className="section-header">
          <span style={{ fontSize: '18px' }}>✏️</span>
          Update Refund Request Status
        </div>
        {error && (
          <Alert
            className="mb-4"
            message="Update failed"
            description={error}
            type="error"
            showIcon
          />
        )}
        <div className="pt-4">
          <Form
            name="status_form"
            layout="vertical"
            className="status-form p-6"
            initialValues={{
              status: refundRequest?.status,
              reason: null
            }}
            onFinish={onFinish}
            form={form}
          >
            <Space direction="vertical" size={5} className="w-full">
              <Card className="enhanced-card h-full" style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.2s ease',
              }}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={24} xl={24}>
                    <Form.Item
                      name="status"
                      label={<span className="font-semibold text-gray-700">Status</span>}
                      rules={[{ required: true, message: 'Please select a status' }]}
                    >
                      <Select 
                        placeholder="Select Status"
                        className="enhanced-input"
                        style={{
                          borderRadius: '8px',
                          border: '2px solid #e5e7eb',
                          transition: 'border-color 0.2s ease',
                        }}
                      >
                        <Option value="Bank Transfer Failed">Bank Transfer Failed</Option>
                        <Option value="RECEIVED REQUEST">RECEIVED REQUEST</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={24} xl={24}>
                    <Form.Item
                      name="reason"
                      label={<span className="font-semibold text-gray-700">Reason</span>}
                      rules={[{ required: true, message: 'Please enter reason' }]}
                    >
                      <Input.TextArea
                        rows={4}
                        placeholder="Enter reason for this status update"
                        className="enhanced-input"
                        style={{
                          borderRadius: '8px',
                          border: '2px solid #e5e7eb',
                          transition: 'border-color 0.2s ease',
                          resize: 'vertical'
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="enhanced-button"
                    loading={loading}
                    style={{
                      background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                      border: 'none',
                      borderRadius: '8px',
                      height: '40px',
                      fontSize: '16px',
                      fontWeight: '600',
                      boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-1px)';
                      e.currentTarget.style.boxShadow = '0 6px 16px rgba(55, 118, 47, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(55, 118, 47, 0.3)';
                    }}
                  >
                    {isEdit ? '✏️ Update' : '📝 Submit'}
                  </Button>
                </Form.Item>
              </Card>
            </Space>
          </Form>

          <Modal
            title={
              <div style={{
                background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                color: 'white',
                padding: '12px 16px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                margin: '-24px -24px 0 -24px',
              }}>
                <span style={{ fontSize: '18px' }}>{isEdit ? '✏️' : '📝'}</span>
                {isEdit ? 'Confirm Status Update' : 'Confirm Status Submission'}
              </div>
            }
            open={isModalOpen}
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            confirmLoading={loading}
            className="enhanced-modal"
            okText={isEdit ? 'Yes, Update Status' : 'Yes, Submit Status'}
            cancelText="Cancel"
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
            }}
          >
            <div className="enhanced-card p-4" style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
            }}>
              <p className="text-gray-700 font-medium">
                Are you sure you want to {isEdit ? 'update' : 'submit'} this status?
              </p>
              <p className="text-gray-600 mb-0">
                New status: <span className="font-semibold text-blue-600">{form.getFieldValue('status') || '-'}</span>
              </p>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  )
}

export default EditRefundRequestStatus
